import * as React from "react";
const SvgSectionExpandIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<path d="M6 7L9.82322 3.17678C9.92085 3.07915 10.0791 3.07915 10.1768 3.17678L14 7" stroke="#808080" strokeLinecap="round" /><path d="M6 13L9.82322 16.8232C9.92085 16.9209 10.0791 16.9209 10.1768 16.8232L14 13" stroke="#808080" strokeLinecap="round" /></svg>;
export default SvgSectionExpandIcon;